import actions from './actions'

export default function WorkOrderInventoryLogsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WorkOrderInventoryLog:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WorkOrderInventoryLog:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WorkOrderInventoryLog:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WorkOrderInventoryLog:
      return {
        ...state,
        editing: { workOrderInventoryLogID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WorkOrderInventoryLog_RECIEVED ||
      actions.UPDATE_WorkOrderInventoryLog_RECIEVED ||
      actions.DELETE_WorkOrderInventoryLog_RECIEVED:
      return {
        ...state,
        editing: { workOrderInventoryLogID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
